/** The same limits the BFF enforces (MK42-5833): checked here first so a wrong file fails at once, not after the upload. */
export const UPLOAD_MAX_BYTES = 50 * 1024 * 1024;
export const ALLOWED_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'webp', 'gif', 'txt', 'csv', 'docx', 'xlsx', 'pptx', 'zip'];

/** Why this file will not be sent, or null when it may go. The server checks the content as well. */
export function precheck(file: { name: string; size: number }): string | null {
  const ext = file.name.includes('.') ? file.name.split('.').pop()!.toLowerCase() : '';
  if (!ALLOWED_EXTENSIONS.includes(ext)) return `Такой тип файла не принимаем. Можно: ${ALLOWED_EXTENSIONS.join(', ')}`;
  if (file.size === 0) return 'Файл пустой';
  if (file.size > UPLOAD_MAX_BYTES) return 'Файл больше 50 МБ';
  return null;
}
